export default __webpack_public_path__ + "static/px4-e34b02282c33944001ed38023d0972a9.jpg";